import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function ForbiddenPage() {
  return (
    <>
      <SEOHead
        title="403 - Adgang nægtet | Djurs Massage"
        description="Du har ikke adgang til denne side hos Djurs Massage i Ryomgård. Gå til forsiden for at se behandlinger og tidsbestilling."
      />

      <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl text-center space-y-6 bg-white p-8 sm:p-12 rounded-3xl border border-[#E8E1D5] shadow-xs">
          <div className="w-16 h-16 rounded-2xl bg-amber-50 text-amber-700 border border-amber-200 flex items-center justify-center mx-auto text-2xl">
            <i className="fa-solid fa-lock" aria-hidden="true" />
          </div>

          <div>
            <span className="text-xs uppercase tracking-wider font-semibold text-amber-700">Fejlkode 403</span>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1E3A5F] font-serif mt-1">
              Adgang nægtet
            </h1>
            <p className="text-slate-600 text-sm sm:text-base mt-3 leading-relaxed">
              Du har ikke adgang til denne side eller ressource. Benyt venligst knapperne nedenfor for at vende tilbage til klinikkens åbne sider.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <Link
              to="/"
              className="flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#1E3A5F] hover:bg-[#162F4D] text-white text-xs font-semibold transition-colors shadow"
            >
              <i className="fa-solid fa-house text-[#C9A770]" aria-hidden="true" />
              <span>Gå til startsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#F3F4F6] hover:bg-[#F2ECE3] text-[#1E3A5F] text-xs font-semibold border border-[#D8CDBE] transition-colors"
            >
              <i className="fa-solid fa-envelope text-[#C9A770]" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
